module.exports = __webpack_public_path__ + "img/FindingData-small.19a4c8d0.png";